import '../assets/NcAppNavigationSpacer.css';
import { defineComponent, openBlock, createElementBlock } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper.mjs";
const _hoisted_1 = { class: "app-navigation-spacer" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcAppNavigationSpacer",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("li", _hoisted_1);
    };
  }
});
const NcAppNavigationSpacer = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-277fa710"]]);
export {
  NcAppNavigationSpacer as N
};
//# sourceMappingURL=NcAppNavigationSpacer.mjs.map
